import { GET,POST } from '../utils/http'

/** 获取展览列表 */
export const getExhibitionList = () => GET('/shengbo/open/exhibition/pbExhibition/list')

/** 获取展览列表 */
export const getExhibitionQueryInfo = id => GET('/shengbo/open/exhibition/pbExhibition/queryInfo', { id })

/** 获取展品列详情 */
export const getRelicsQueryById = id => GET('/shengbo/open/exhibition/pbRelics/queryById', { id })

/** 获取单元列详情 */
export const getExhibitionUnitQueryById = id => GET('/shengbo/open/exhibition/pbExhibitionUnit/queryById', { id })

/** 视频短视频 */
export const getPbShortVideoList = ({ pageNo = 1, pageSize = 10 }) => GET('/shengbo/open/media/pbShortVideo/list', { pageNo, pageSize })

/** 获取线上展览列表 */
export const getListByType = (
  { type = 1, secondType = 1, pageNo, pageSize = 10 }
) => GET(
  '/shengbo/open/basicinfo/pbLink/list',
  { type, secondType, pageNo, pageSize }
)

// 获取晋界讲坛列表
export const getLectureList = (
  { pageNo, pageSize = 10 }
) => GET(
  '/shengbo/open/basicinfo/pbForum/list',
  { pageNo, pageSize }
)
/** 跳转小程序 获取相关信息 */
// export const wxInfo=(params)=>POST('/shengbo/open/wx/getSignature',params)
// export const wxInfo=(params)=>POST(`/shengbo/open/wx/getAcs?appName=${params.appName}`)
export const wxInfo=(params)=>POST(`/shengbo/open/wx/getURLScheme?appName=${params.appName}`)
/** 获取直播预告列表 */
export const getLivePreviewList = () => GET('/shengbo/open/media/pbLive/all')

/** 获取观看回放列表 */
export const getPlaybackList = () => GET('/shengbo/open/media/pbLivePlayback/all')

/** 获取文物 */
export const getRecil = (prames) => GET('/jeecg-boot/wechat/relicManage/ivCulturalRelicModel/queryByRelicId', prames)
